import { render } from "./PostActionMenu.vue?vue&type=template&id=2bc752d8"
import script from "./PostActionMenu.vue?vue&type=script&lang=ts"
export * from "./PostActionMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script